import { editorLocalization } from "../editorLocalization";

export var czStrings = {
  ed: {
    addNewPage: "Přidat novou stránku",
    bold: "Tučně",
    chooseElement: "Vybrat dokument...",
    copy: "Kopírovat",
    copyTooltip: "Zkopírovat výběr do schránky",
    correctJSON: "Opravte JSON.",
    cut: "Vyjmout",
    cutTooltip: "Vyjmout výběr do schránky",
    defaultLocale: "Výchozí ({0})",
    deletePage: "Smazat stránku",
    designer: "Návrhář průzkumů",
    edit: "Upravit",
    editPage: "Upravit stránku",
    embedSurvey: "Vložit průzkum",
    fpAddQuestion: "Přidat otázku...",
    generateReadableJSON: "Generovat čitelný JSON",
    generateValidJSON: "Generovat platný JSON",
    hidePanel: "Skrýt panel",
    italic: "Kurzíva",
    jsonEditor: "Editor JSON",
    lg: {
      actionInvalid: "Opravte prosím problémy v akcích.",
      actions: "Akce",
      actionsEditorTitle: "Definovat akce",
      addNewAction: "Přidat novou akci",
      addNewItem: "Přidat nové pravidlo",
      completedHtmlOnConditionDescription: "Pokud logický výraz vrátí hodnotu true, změní se výchozí text stránky s poděkováním na zadaný text.",
      completedHtmlOnConditionName: "Vlastní text stránky s poděkováním",
      completedHtmlOnConditionText: "Zobrazit vlastní text pro stránku s poděkováním.",
      conditions: "Podmínky",
      deleteAction: "Smazat akci",
      expressionEditorTitle: "Definovat podmínky",
      expressionInvalid: "Logický výraz je prázdný nebo neplatný. Opravte jej.",
      itemExpressionText: "Pokud výraz „{0}“ vrátí hodnotu true:",
      noActionError: "Přidejte alespoň jednu akci.",
      page_visibilityDescription: "Zobrazení stránky, když se logický výraz vrátí jako true. V opačném případě zůstane neviditelná.",
      page_visibilityName: "Viditelnost stránky",
      page_visibilityText: "Zobrazit stránku {0}",
      panel_enableDescription: "Panel a všechny prvky v něm se aktivují, když logický výraz vrátí hodnotu true. V opačném případě je nechte vypnuté.",
      panel_enableName: "Zapnutí/vypnutí panelu",
      panel_enableText: "Povolit panel {0}",
      panel_visibilityDescription: "Zobrazení panel, když se logický výraz vrátí jako true. V opačném případě zůstane neviditelný.",
      panel_visibilityName: "Viditelnost panelu",
      panel_visibilityText: "Zobrazit panel {0}",
      question_enableDescription: "Povolit otázku, když logický výraz vrátí hodnotu true. V opačném případě zůstane neviditelná.",
      question_enableName: "Zapnutí/vypnutí otázky",
      question_enableText: "Povolit otázku {0}",
      question_requireDescription: "Otázka se stává povinnou, když logický výraz vrátí hodnotu true.",
      question_requireName: "Otázka nepovinná vyžadována",
      question_requireText: "Otázka {0} je povinná",
      question_visibilityDescription: "Zobrazit otázku, když logický výraz vrátí hodnotu true. V opačném případě zůstane neviditelná.",
      question_visibilityName: "Viditelnost otázky",
      question_visibilityText: "Zobrazit otázku {0}",
      selectedActionCaption: "Vyberte akci, kterou chcete přidat...",
      trigger_completeDescription: "Když logický výraz vrátí hodnotu true, průzkum je dokončen a koncovému uživateli se zobrazí stránka s poděkováním.",
      trigger_completeName: "Dokončení průzkumu",
      trigger_completeText: "Průzkum se stává dokončeným",
      trigger_copyvalueDescription: "Pokud se změní hodnoty otázek, které jsou použity v logickém výrazu, a logický výraz vrátí hodnotu true, pak se hodnota jedné vybrané otázky zkopíruje do jiné vybrané otázky.",
      trigger_copyvalueName: "Kopírovat hodnotu otázky",
      trigger_copyvalueText: "Kopírovat do otázky: {0} hodnota z otázky {1}",
      trigger_runExpressionDescription: "Pokud logický výraz vrátí hodnotu true, provede se vlastní výraz. Výsledek tohoto výrazu můžete volitelně nastavit do vybrané otázky.",
      trigger_runExpressionName: "Spuštění vlastního výrazu",
      trigger_runExpressionText1: "Spustit výraz: „{0}“",
      trigger_runExpressionText2: " a zpochybnit jeho výsledek: {0}",
      trigger_setvalueDescription: "Pokud se změní hodnoty otázek, které jsou použity v logickém výrazu, a logický výraz vrátí hodnotu true, nastaví se hodnota na vybranou otázku.",
      trigger_setvalueName: "Nastavení hodnoty otázky",
      trigger_setvalueText: "Zpochybnit: {0} hodnota {1}",
      trigger_skipDescription: "Pokud logický výraz vrátí hodnotu true, průzkum přejde na vybranou otázku/zaměří se na ni.",
      trigger_skipName: "Přeskočit na otázku",
      trigger_skipText: "Průzkum přeskočí na otázku {0}"
    },
    logic: "Logika průzkumu",
    modified: "Upraveno",
    moveLeft: "Přejděte doleva",
    moveRight: "Přejděte doprava",
    navigateToMsg: "Museli jste přejít na:",
    newPageName: "stránka",
    newPanelName: "panel",
    newQuestionName: "otázka",
    newTextItemName: "text",
    options: "Možnosti",
    paste: "Vložit",
    pasteTooltip: "Vložit ze schránky",
    "property-grid": "Vlastnosti",
    propertyEditorError: "Chyba:",
    redo: "Opětovně vrátit",
    redoTooltip: "Znovu provést změnu",
    resultsDisplayValue: "Hodnota zobrazení",
    resultsName: "Název otázky",
    resultsTitle: "Nadpis otázky",
    resultsValue: "Hodnota odpovědi",
    saved: "Uloženo",
    saveError: "Chyba! Obsah editoru není uložen.",
    saveSurvey: "Uložit průzkum",
    saveSurveyTooltip: "Uložit průzkum",
    saving: "Ukládání",
    selectPage: "Vyberte stránku...",
    settings: "Nastavení průzkumu",
    settingsTooltip: "Otevřít nastavení průzkumu",
    showPanel: "Zobrazit panel",
    survey: "Průzkum",
    surveyResults: "Výsledek průzkumu: ",
    surveyResultsJson: "Jako JSON",
    surveyResultsTable: "Jako tabulka",
    testSurvey: "Otestovat průzkum",
    testSurveyAgain: "Znovu otestovat průzkum",
    testSurveyWidth: "Šířka průzkumu: ",
    toolbox: "Sada nástrojů",
    toolboxGeneralCategory: "Obecné",
    translation: "Překlad",
    translationAddLanguage: "Vyberte jazyk pro překlad",
    translationExportToSCVButton: "Export do CSV",
    translationImportFromSCVButton: "Import z CSV",
    translationMergeLocaleWithDefault: "Sloučit {0} s výchozím lokálem",
    translationNoStrings: "Žádné řetězce k překladu. Změňte filtr.",
    translationShowAllPages: "Zobrazit všechny stránky",
    translationShowAllStrings: "Zobrazit všechny řetězce",
    underline: "Podtržení",
    undo: "Zrušit",
    undoTooltip: "Vrátit poslední změnu"
  },
  ew: {
    angular: "Použít verzi Angular",
    bootstrap: "Pro framework bootstrap",
    darkblue: "Tmavěmodrý motiv",
    darkrose: "Tmavěrůžový motiv",
    default: "Výchozí motiv",
    jquery: "Použít verzi jQuery",
    knockout: "Použít verzi Knockout",
    loadFromServer: "Načíst průzkum JSON ze serveru",
    modern: "Moderní motiv",
    orange: "Oranžový motiv",
    react: "Použít verzi React",
    showInWindow: "Zobrazit průzkum v okně",
    showOnPage: "Zobrazit průzkum na stránce",
    stone: "Kamenný motiv",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript",
    titleScript: "Skripty a styly",
    vue: "Použít verzi Vue",
    winter: "Zimní motiv",
    winterstone: "Téma zima-kámen"
  },
  op: {
    allof: "všechny",
    and: "a",
    anyof: "žádný z",
    contains: "obsahuje",
    empty: "je prázdný",
    equal: "rovná se",
    greater: "větší",
    greaterorequal: "větší nebo se rovná",
    less: "nižší",
    lessorequal: "nižší nebo se rovná",
    notcontains: "neobsahuje",
    notempty: "není prázdný",
    notequal: "nerovná se",
    or: "nebo"
  },
  p: {
    title: {
      title: "Nechte pole prázdné, pokud je stejné jako „Název”"
    }
  },
  pe: {
    aceEditorHelp: "Stisknutím kláves ctrl+mezerník získáte nápovědu k dokončení výrazu",
    aceEditorPanelTitle: "Aktuální panel",
    aceEditorRowTitle: "Aktuální řádek",
    add: "Přidat",
    addCondition: "Přidat podmínku",
    addItem: "Kliknutím přidáte položku...",
    addLogo: "Přidat logo...",
    addNew: "Přidat novou",
    addNone: "Žádné",
    addOther: "Ostatní",
    addRowLocation: "Přidat umístění tlačítka řádku",
    addRowText: "Přidat text tlačítka řádku",
    addSelectAll: "Vybrat vše",
    allowAddPanel: "Povolit přidání panelu",
    allowDigits: "Povolit číslice",
    allowEmptyResponse: "Povolit prázdnou odpověď",
    allowRemovePanel: "Povolit odstranění panelu",
    and: "A",
    apply: "Použít",
    assistantTitle: "Dostupné otázky:",
    back: "Návrat bez uložení",
    backTooltip: "Návrat bez uložení",
    buildExpression: "Vytvořit",
    cancel: "Zrušit",
    cellsDefaultRow: "Výchozí texty buněk",
    cellsEmptyRowsColumns: "Měl by existovat alespoň jeden sloupec nebo řádek.",
    cellType: "Typ buňky",
    changeLogo: "Změnit logo...",
    choicesMax: "Maximální hodnota pro automaticky generované položky",
    choicesMin: "Minimální hodnota pro automaticky generované položky",
    choicesOrder: "Vyberte pořadí voleb",
    choicesStep: "Rozdíl mezi automaticky generovanými položkami",
    clearInvisibleValues: "Vymazat neviditelné hodnoty",
    colCount: "Počet sloupců",
    cols: "Počet sloupců",
    columnEdit: "Upravit sloupec: {0}",
    columnLayout: "Rozložení sloupců",
    completeText: "Úplný text tlačítka",
    conditionActionEmpty: "Vyberte akci",
    conditionSelectPage: "Vyberte stránku...",
    conditionSelectPanel: "Vyberte panel...",
    conditionSelectQuestion: "Vyberte otázku...",
    conditionValueQuestionTitle: "Zadejte/vyberte hodnotu",
    cookieName: "Název souboru cookie (pro zakázání dvojího lokálního spuštění průzkumu)",
    createtrigger: "Vytvořte spouštěč",
    defaultValue: "Výchozí hodnota",
    delete: "Smazat",
    descriptionPlaceholder: "Zadejte popis",
    edit: "Upravit",
    editChoices: "Upravit volby",
    editExpression: "Upravit",
    editProperty: "Upravit vlastnost „{0}“",
    editText: "Text tlačítka úpravy",
    enterNewValue: "Zadejte hodnotu.",
    expandCollapseTitle: "Rozbalit/sbalit název",
    expression: "Výraz",
    expressionHelp: "Pro přístup k hodnotám otázek můžete použít složené závorky: {otázka1} + {otázka2}, ({cena}*{množství}) * (100 - {sleva}). Můžete použít funkce jako: iif(), today(), age(), min(), max(), count(), avg() a další.",
    expressionIsEmpty: "Výraz je prázdný",
    fastEntry: "Rychlý vstup",
    firstPageIsStarted: "První stránka průzkumu je úvodní stránka.",
    focusFirstQuestionAutomatic: "Zaměřte se na první otázku týkající se změny stránky",
    formEntry: "Vstupní formulář",
    goNextPageAutomatic: "Po zodpovězení všech otázek automaticky přejít na další stránku",
    hasNone: "Nemá žádnou položku",
    hasOther: "Má jinou položku",
    hasSelectAll: "Vybral/a všechny položky",
    html: "HTML",
    imageHeight: "Výška obrázku",
    imageLink: "Odkaz na obrázek",
    imageWidth: "Šířka obrázku",
    inputType: "Typ vstupu",
    isAllRowRequired: "Požadovat odpověď pro všechny řádky",
    isRequired: "Je vyžadovaný?",
    isSinglePage: "Zobrazit všechny prvky na jedné stránce",
    itemEdit: "Upravit položku: {0}",
    items: "[ Položky: {0} ]",
    itemSelectorEmpty: "Vyberte prvek",
    itemView: "Zobrazit položku: {0}",
    keyboardAdornerTip: "Stisknutím klávesy enter upravíte položku, stisknutím klávesy delete položku odstraníte, stisknutím klávesy alt plus šipky nahoru nebo šipky dolů položku přesunete.",
    keyboardMoveItemsTip: "Stisknutím klávesy alt a šipky nahoru nebo šipky dolů přesunete položku",
    landscapeOrientation: "Na šířku",
    listIsEmpty: "Přidat novou položku",
    locale: "Výchozí jazyk",
    logoPosition: "Pozice loga",
    logoPositions: {
      bottom: "Dole",
      left: "Vlevo",
      none: "Odstranit logo",
      right: "Vpravo",
      top: "Nahoře"
    },
    maxCount: "Maximální počet",
    maxLength: "Maximální délka",
    maxRateDescription: "Popis maximální sazby",
    maxSize: "Maximální velikost souboru v bajtech",
    maxTimeToFinish: "Maximální doba pro dokončení průzkumu",
    maxTimeToFinishPage: "Maximální doba pro dokončení stránky v průzkumu",
    maxValue: "Maximální hodnota",
    minCount: "Minimální počet",
    minLength: "Minimální délka",
    minRateDescription: "Popis minimální frekvence",
    minValue: "Minimální hodnota",
    mode: "Režim (pouze pro úpravy/čtení)",
    move: "Přesunout",
    name: "Název",
    noFile: "Nebyl vybrán žádný soubor",
    noneText: "Žádný text položky",
    noquestions: "V průzkumu není žádná otázka.",
    ok: "OK",
    optionsCaption: "Popisek možností",
    or: "Nebo",
    otherText: "Další text položky",
    pageDescriptionPlaceholder: "Zadejte popis stránky",
    pageNextText: "Text tlačítka další stránky",
    pagePrevText: "Text tlačítka předchozí stránky",
    pageTitlePlaceholder: "Sem zadejte název stránky",
    panelAddText: "Přidávání textu na panel",
    panelRemoveText: "Odstraňování textu panelu",
    path: "Cesta",
    placeholder: "Vstupní zástupný symbol",
    previewText: "Text tlačítka náhledu",
    propertyIsEmpty: "Zadejte hodnotu",
    propertyIsNoUnique: "Zadejte jedinečnou hodnotu",
    propertyNameIsNotUnique: "Zadejte jedinečný název",
    qEditorTitle: "Upravit: {0}",
    questionErrorLocation: "Umístění chyby v otázce",
    questionsOrder: "Pořadí prvků na stránce",
    questionStartIndex: "Index začátku otázky (1, 2 nebo A, a)",
    questionTitleLocation: "Umístění názvu otázky",
    questionTitleTemplate: "Šablona názvu otázky, výchozí je: „{no}. {require} {title}“",
    rateMax: "Maximální frekvence",
    rateMin: "Minimální frekvence",
    rateStep: "Krok frekvence",
    refresh: "Obnovit",
    regex: "Pravidelný výraz",
    remove: "Odebrat",
    removeAll: "Odstranit vše",
    removeRowText: "Odebrat text tlačítka řádku",
    renderMode: "Režim vykreslování",
    requiredErrorText: "Požadovaný text chyby",
    requiredText: "Požadované symboly otázky",
    reset: "Resetovat",
    rowCount: "Počet řádků",
    rowid: "ID řady",
    rows: "Počet řádků",
    save: "Uložit",
    saveAndBack: "Uložit a vrátit",
    saveAndBackTooltip: "Uložit a vrátit",
    saveTooltip: "Uložit",
    selectAllText: "Vyberte veškerý text položky",
    sendResultOnPageNext: "Odeslání výsledků průzkumu na další straně",
    showChoices: "Zobrazit volby",
    showCompletedPage: "Zobrazení dokončené stránky na konci (completedHtml)",
    showMore: "Další podrobnosti naleznete v dokumentaci",
    showNavigationButtons: "Zobrazit navigační tlačítka (výchozí navigace)",
    showOptionsCaption: "Zobrazit popisek možností",
    showPageNumbers: "Zobrazit čísla stránek",
    showPageTitles: "Zobrazit názvy stránek",
    showPrevButton: "Zobrazit předchozí tlačítko (uživatel se může vrátit na předchozí stránku)",
    showPreview: "Zobrazit oblast náhledu",
    showProgressBar: "Zobrazit ukazatel průběhu",
    showQuestionNumbers: "Zobrazit čísla otázek",
    showTimerPanel: "Zobrazit panel časovače",
    showTimerPanelMode: "Zobrazit režim panelu časovače",
    showTitle: "Zobrazit/skrýt název",
    simulator: "Vybrat zařízení",
    startSurveyText: "Text tlačítka zahájení",
    startWithNewLine: "Začátek s novým řádkem?",
    storeDataAsText: "Uložit obsah souboru ve výsledku JSON jako text",
    storeOthersAsComment: "Uložení hodnoty „others“ do samostatného pole",
    surveyDescriptionPlaceholder: "Zadejte popis průzkumu",
    surveyEditorTitle: "Upravit nastavení průzkumu",
    surveyTitlePlaceholder: "Sem zadejte název průzkumu",
    tabs: {
      calculatedValues: "Vypočítané hodnoty",
      cells: "Buňky",
      choices: "Volby",
      choicesByUrl: "Volby z webu",
      columns: "Sloupce",
      completedHtml: "Dokončené HTML",
      completedHtmlOnCondition: "Dokončeno HTML na podmínku",
      data: "Data",
      enableIf: "Povolené, pokud",
      fileOptions: "Možnosti",
      general: "Obecné",
      html: "Editor HTML",
      items: "Položky",
      layout: "Rozložení",
      loadingHtml: "Načítání HTML",
      logic: "Logika",
      logo: "Logo v názvu průzkumu",
      matrixChoices: "Výchozí volby",
      multipleTextItems: "Textové vstupy",
      navigation: "Navigace",
      numbering: "Číslování",
      others: "Ostatní",
      pages: "Stránky",
      question: "Otázka",
      rateValues: "Hodnoty sazeb",
      requiredIf: "Vyžadované, pokud",
      rows: "Řádky",
      showOnCompleted: "Zobrazit na stránce Dokončeno",
      slider: "Posuvník",
      templateTitle: "Název šablony",
      timer: "Časovač/kvíz",
      totals: "Součty",
      triggers: "Spouštěče",
      validation: "Ověřování",
      validators: "Validátory",
      visibleIf: "Viditelné, pokud"
    },
    testService: "Testování služby",
    text: "Text",
    title: "Titul",
    titleKeyboardAdornerTip: "Zadejte tlačítko k úpravě",
    titleName: "Název titulu",
    titlePlaceholder: "Sem zadejte název",
    totalCurrency: "Celková měna",
    totalDisplayStyle: "Celkový styl zobrazení",
    totalExpression: "Celkový výraz",
    totalFormat: "Celkový formát",
    totalText: "Celkový text",
    totalType: "Celkový typ",
    triggerCompleteText: "Vyplňte průzkum, pokud se vám to podaří.",
    triggerFromName: "Zkopírovat hodnotu z: ",
    triggerGotoName: "Přejít na otázku:",
    triggerIsVariable: "Nevkládejte proměnnou do výsledku průzkumu.",
    triggerMakePagesVisible: "Zobrazit stránky:",
    triggerMakeQuestionsVisible: "Zobrazit prvky:",
    triggerNotSet: "Spouštěč není nastaven",
    triggerOn: "Zapnout ",
    triggerRunExpression: "Spustit tento výraz:",
    triggerRunExpressionEmpty: "Zadejte platný výraz",
    triggerRunIf: "Spustit, pokud",
    triggerSetToName: "Změnit hodnotu: ",
    triggerSetValue: "do: ",
    url: "URL",
    value: "Hodnota",
    valueName: "Název hodnoty",
    view: "Zobrazit",
    visible: "Je viditelný?"
  },
  pv: {
    all: "vše",
    asc: "vzestupný",
    both: "obě",
    bottom: "dole",
    buttons: "tlačítka",
    collapsed: "sbalený",
    color: "barva",
    correctQuestions: "správné otázky",
    currency: "měna",
    date: "datum",
    datetime: "datumčas",
    "datetime-local": "datumčas-místní",
    decimal: "desetinné číslo",
    default: "výchozí",
    desc: "sestupný",
    display: "zobrazit",
    edit: "upravit",
    email: "e-mail",
    expanded: "rozbalený",
    false: "nepravdivé",
    firstExpanded: "firstExpanded",
    hidden: "skrytý",
    hide: "skrýt",
    horizontal: "horizontální",
    indeterminate: "neurčitý",
    inherit: "zdědit",
    initial: "úvodní",
    left: "vlevo",
    list: "seznam",
    month: "měsíc",
    none: "žádný",
    noPreview: "bez náhledu",
    number: "číslo",
    off: "vypnout",
    on: "zapnout",
    onComplete: "onComplete",
    onHidden: "onHidden",
    onNextPage: "onNextPage",
    onPage: "onPage",
    onPanel: "onPanel",
    onSurvey: "onSurvey",
    onValueChanged: "onValueChanged",
    page: "stránka",
    pages: "stránky",
    password: "heslo",
    percent: "procenta",
    progressBottom: "progressBottom",
    progressTop: "progressTop",
    progressTopBottom: "progressTopBottom",
    questionPerPage: "otázka na stránku",
    questions: "otázky",
    random: "náhodný",
    range: "rozsah",
    requiredQuestions: "povinné otázky",
    show: "zobrazit",
    showAllQuestions: "zobrazit náhled se všemi otázkami",
    showAnsweredQuestions: "zobrazit náhled se zodpovězenými otázkami",
    singlePage: "jedna stránka",
    standard: "standardní",
    survey: "průzkum",
    tel: "tel",
    text: "text",
    time: "čas",
    top: "nahoře",
    topBottom: "nahoře a dole",
    true: "pravdivé",
    underInput: "pod vstupem",
    underTitle: "pod nadpisem",
    url: "URL",
    vertical: "vertikální",
    week: "týden"
  },
  qt: {
    boolean: "Boolean",
    checkbox: "Zaškrtávací pole",
    comment: "Komentář",
    default: "Výchozí",
    dropdown: "Rozbalovací nabídka",
    expression: "Výraz (pouze pro čtení)",
    file: "Soubor",
    flowpanel: "Panel průběhu",
    html: "HTML",
    image: "Obrázek",
    imagepicker: "Nástroj pro výběr obrázku",
    matrix: "Matrix (jedna volba)",
    matrixdropdown: "Matrix (výběr z více možností)",
    matrixdynamic: "Matice (dynamické řádky)",
    multipletext: "Více textů",
    panel: "Panel",
    paneldynamic: "Panel (dynamické panely)",
    radiogroup: "Radiogroup",
    ranking: "Pořadí",
    rating: "Hodnocení",
    signaturepad: "Podpisová podložka",
    text: "Jeden vstup"
  },
  survey: {
    addLogicItem: "Vytvořte pravidlo pro přizpůsobení průběhu průzkumu.",
    addToToolbox: "Přidat do sady nástrojů",
    convertTo: "Převést na",
    copy: "Kopírovat",
    deletePanel: "Odstranit panel",
    deleteQuestion: "Odstranit otázku",
    drag: "Přetáhnout prvek",
    dropQuestion: "Sem napište otázku ze sady nástrojů.",
    duplicate: "Duplikovat",
    edit: "Upravit",
    externalHelpLink: "Podívejte se a naučte se vytvářet průzkumy",
    externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
  },
  triggers: {
    completetrigger: "dokončit průzkum",
    copyvaluetrigger: "zkopírovat hodnotu",
    runexpressiontrigger: "spustit výraz",
    setvaluetrigger: "nastavit hodnotu",
    skiptrigger: "přeskočit na otázku",
    visibletrigger: "změnit viditelnost (zastaralé)"
  },
  ts: {
    selectPage: "Vyberte stránku a otestujte ji:",
    showInvisibleElements: "Zobrazit neviditelné prvky"
  },
  validators: {
    answercountvalidator: "počet odpovědí",
    emailvalidator: "e-mail",
    expressionvalidator: "výraz",
    numericvalidator: "číselné",
    regexvalidator: "regex",
    textvalidator: "text"
  }
};

editorLocalization.locales["cs"] = czStrings;
